import {
  sanitizeBlogHtml as sanitizeBlogHtmlForPlatform,
  sanitizeHtml as sanitizeHtmlForPlatform,
  sanitizeLabelHtml as sanitizeLabelHtmlForPlatform,
} from '#sanitize-html-platform'

/** Sanitize user-supplied or API-supplied HTML for inline v-html use. */
export function sanitizeHtml(html: string): string {
  return sanitizeHtmlForPlatform(html)
}

/**
 * Sanitize inline label HTML that may contain anchor links with target="_blank"
 * (e.g. legal-document links in checkbox labels on onboarding/profile forms).
 * Allows only inline elements plus anchor tags; preserves target and rel so
 * links open in a new tab without losing in-progress form state.
 */
export function sanitizeLabelHtml(html: string): string {
  return sanitizeLabelHtmlForPlatform(html)
}

/**
 * Sanitize CMS-authored blog/article content.
 * Keeps a wider set of elements (iframes for embeds, target for links, etc.)
 * while still stripping any injected scripts or event handlers.
 */
export function sanitizeBlogHtml(html: string): string {
  return sanitizeBlogHtmlForPlatform(html)
}
